<template>
  <van-form ref="vanForm" validate-first class="mode">
    <van-cell-group>
      <template v-for="(item, key) of form">
        <van-field
          v-if="item.isSelect"
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.value ? item.rules : []"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop(item.name, key)"
        />
        <van-field
          v-else
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.value ? item.rules : []"
          placeholder="请输入"
          @input="val => changeValue(val, key)"
        />
      </template>
    </van-cell-group>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="textList.title"
        show-toolbar
        :columns="textList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, textList.field);
          }
        "
      />
    </van-popup>
  </van-form>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        cyxm: {
          name: "姓名",
          text: "",
          value: ""
        },
        age: {
          name: "年龄",
          text: "",
          value: "",
          rules: [
            {
              pattern: /^[1-9]{1}\d{0,2}$/,
              message: "请输入正确的年龄"
            }
          ]
        },
        gx: {
          name: "关系",
          text: "",
          value: "",
          isSelect: true
        },
        zzmm: {
          name: "政治面貌",
          text: "",
          value: "",
          isSelect: true
        },
        gzdw: {
          name: "工作单位",
          text: "",
          value: ""
        },
        zw: {
          name: "职位",
          text: "",
          value: "",
          isSelect: true
        },
        gzdwxq: {
          name: "工作单位地址电话",
          text: "",
          value: "",
          rules: [
            {
              pattern: /\d{1}|\d-\d-\d/,
              message: "请输入正确的工作单位地址电话"
            }
          ]
        }
      },
      show: false,
      textList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeValue(val, field) {
      this.form[field].value = val;
    },
    async saveData() {
      this.$refs.vanForm.validate().then(
        async () => {
          let params = {
            type: "jtcy",
            cyxm: this.form.cyxm.value,
            age: this.form.age.value,
            gxm: this.form.gx.value,
            zzmm: this.form.zzmm.value,
            gzdw: this.form.gzdw.value,
            cym: this.form.zw.value,
            gzdwxq: this.form.gzdwxq.value,
            xs0106id: this.info.xs0106id
          };

          const res = await Api.saveXjxx(params);
          if (res.code == 1) {
            if (this.info.type === "add") {
              this.$toast.success("学籍" + this.info.title + "增加已提交");
            } else {
              this.$toast.success("学籍" + this.info.title + "修改已提交");
            }
            setTimeout(() => {
              this.$router.replace(
                "/xsxxxgsq/index?active=" + this.info.active
              );
            }, 1500);
          }
        },
        () => {}
      );
    },
    async getList() {
      const res = await Api.findStudentInfo({
        type: "jtcy",
        xs0106id: this.info.xs0106id
      });
      if (res.code === "1") {
        // 关系
        this.columns.gx = [
          {
            values: [
              { text: "父亲", value: "0" },
              { text: "母亲", value: "1" },
              { text: "兄弟姐妹", value: "2" },
              { text: "其它", value: "3" }
            ]
          }
        ];
        let message = res.data.jtcyInfo;
        let defaultGx = 0;
        let defaultZzmm = 0;
        let defaultZw = 0;
        // 政治面貌
        this.columns.gx = [
          {
            values: res.data.selectDataMap.gx.map((item, index) => {
              if (this.info.type === "update" && item.dm === message.gxm) {
                defaultGx = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultGx
          }
        ];
        // 政治面貌
        this.columns.zzmm = [
          {
            values: res.data.selectDataMap.zzmm.map((item, index) => {
              if (this.info.type === "update" && item.dm === message.zzmmm) {
                defaultZzmm = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultZzmm
          }
        ];
        // 职位
        this.columns.zw = [
          {
            values: res.data.selectDataMap.zw.map((item, index) => {
              if (this.info.type === "update" && item.dm === message.zydm) {
                defaultZw = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultZw
          }
        ];

        if (this.info.type === "update") {
          this.form = {
            cyxm: {
              name: "姓名",
              text: message.cyxm,
              value: message.cyxm
            },
            age: {
              name: "年龄",
              text: message.age,
              value: message.age,
              rules: [
                {
                  pattern: /^[1-9]{1}\d{0,2}$/,
                  message: "请输入正确的年龄"
                }
              ]
            },
            gx: {
              name: "关系",
              text: message.gxmc,
              value: message.gxm,
              isSelect: true
            },
            zzmm: {
              name: "政治面貌",
              text: message.zzmmmc,
              value: message.zzmmm,
              isSelect: true
            },
            gzdw: {
              name: "工作单位",
              text: message.gzdw,
              value: message.gzdw
            },
            zw: {
              name: "职位",
              text: message.zymc,
              value: message.zydm,
              isSelect: true
            },
            gzdwxq: {
              name: "工作单位地址电话",
              text: message.gzdwxq,
              value: message.gzdwxq,
              rules: [
                {
                  pattern: /\d{1}|\d-\d-\d/,
                  message: "请输入正确的工作单位地址电话"
                }
              ]
            }
          };
        }
      }
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.textList.title = title;
      this.textList.field = field;
      this.textList.columns = this.columns[field];
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field].text = value[0].text;
      this.form[field].value = value[0].value;
      //   this.getList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/student/xsxxxgsq/mode/jtcy.vue